import { AddressRequestModel } from 'src/api/models';
import { SetState } from 'zustand';
import type { StoreState } from './index';

type Hoa = { hasHoa: false } | { hasHoa: true; hoaFee: number };

type Mortgage =
  | { hasMortgage: false }
  | { hasMortgage: true; mortgage: number };

type PriceEstimate = {
  estimate: number;
  highRange: number;
  lowRange: number;
};

type RentEstimate = {
  estimate: number;
  highRange: number;
  lowRange: number;
};

type CalculatorAdvanced = {
  yearBuilt?: string;
  lastMajorRenovation?: string;
  ageOfAppliances?: string;
  currentState?: string;
  lookingForTenant?: boolean;
  selectedPlan?: string;
};

type SliderEstimate = {
  rentEstimate: number;
  percentage: number;
};

type Calculator = {
  address?: AddressRequestModel;
  priceEstimate?: PriceEstimate;
  rentEstimate?: RentEstimate;
  hoa?: Hoa;
  mortgage?: Mortgage;
  currentPropertyId?: string;
  currentHomeId?: string;
  sliderEstimate?: SliderEstimate;
  advanced: CalculatorAdvanced;
};

type CalculatorKey = keyof Calculator;

export type CalculatorSlice = {
  calculator: Calculator;
  setValue: (calculatorKey: CalculatorKey) => (value: unknown) => void;
};

const calculator = {
  advanced: {},
};

export const calculatorSlice = (
  set: SetState<StoreState>,
): CalculatorSlice => ({
  calculator,
  setValue: (calculatorKey: CalculatorKey) => (value: unknown) => {
    set((prev) => ({
      calculator: { ...prev.calculator, [calculatorKey]: value },
    }));
  },
});

const setCalculatorValueSelector = (state: StoreState) => state.setValue;
export const setAddressSelector = (state: StoreState) =>
  setCalculatorValueSelector(state)('address');
